<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getUserTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button @click.native="createUser" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
              <template v-if="header.icon">
                <a @click="sortDataTable">
                  <v-icon class="fas fa-caret-down"
                          v-if="sort_date == 'desc'"
                          style="font-size: 12px"></v-icon>
                  <v-icon class="fas fa-caret-up"
                          v-if="sort_date == 'asc'"
                          style="font-size: 12px"></v-icon>
                </a>
              </template>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.firstname}} {{data.lastname}}</td>
            <td>{{data.username}}</td>
            <td>{{data.user_role ? data.user_role.role_name : ''}}</td>
            <td>{{data.email}}</td>
            <td>{{data.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showUserData(data.id)">
                <icon-pencil />
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import IconPencil from "../../../components/Icon/icon-pencil";
  import CircleButton from "../../../components/Button/CircleButton";
  import InputTextField from "../../../components/Input/InputTextField";
  import InputSearch from "../../../components/Input/InputSearch";
  import Paginate from "../../../components/Layout/Paginate";
  import Swal from "sweetalert";
  import Loading from 'vue-loading-overlay';
  export default {
    name: "UserTable",
    components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil, Loading },
    data() {
      return {
        title: "User",
        isLoading: false,
        headers: [
          { id: 1, text: "No." ,icon : null},
          { id: 2, text: "Name" ,icon : null},
          { id: 3, text: "Username" ,icon : null},
          { id: 4, text: "User Role" ,icon : null},
          { id: 5, text: "E-mail" ,icon : null},
          { id: 6, text: "Update date" ,icon : true},
          { id: 7, text: "Edit" ,icon : null},
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        },
        search : '',
        sort_date : 'desc',
      };
    },
    created() {
      this.getUserTable(1);
    },
    methods: {
      goToUserEdit() {
        this.$router.push("/user/edit");
      },
      getUserTable(page) {
        this.isLoading = true;
        this.$store.dispatch("User/getUser",{
          page,
          search : this.search,
          sort_date : this.sort_date,
        }).then(res=>{
          this.dataTable = res.data;
          this.dataPaginate = {
            current_page: res.current_page,
            from: res.from,
            last_page: res.last_page,
            per_page: res.per_page,
            total: res.total,
            to: res.to
          };
          this.isLoading = false;
        });
      },
      async changePage(val){
        this.isLoading = true;
        this.dataPaginate.current_page = val;
        await this.getUserTable(this.dataPaginate.current_page);
        this.isLoading = false;
      },
      showUserData(id) {
        this.isLoading = true;
        this.$store.dispatch("User/showUser",id).then(res=>{
          if(res){
            this.$store.dispatch("User/setFormUser",res).then(()=>{
              this.goToUserEdit();
            });
          }else{
            Swal('','User data not found','error');
          }
          this.isLoading = false;
        }).catch(()=>{
          Swal('','Cannot get data user','error');
          this.isLoading = false;
        })
      },
      createUser() {
        this.$store.dispatch("User/clearFormData").then(()=>{
          this.goToUserEdit();
        })
      },
      searchInput(val){
        this.search = val;
      },
      sortDataTable(){
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
        this.getUserTable(1);
      }

    }
  };
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/table.css";
  @import "../../../assets/css/variables";
  .branch-data {
    background-color: $background-theme;
    margin: 20px;
  }
</style>
